import { graphql } from 'gatsby';
import React, { FC } from 'react';

import Header from 'src/components/Header';
import Heading, { HeadingVariant, HeadingScope } from 'src/components/Heading';
import Grid from 'src/components/Grid';
import Layout from 'src/components/Layout';
import BlogCard from 'src/components/BlogCard';
import Pager from 'src/components/Pager';
import Footer from 'src/components/Footer';

interface BlogProps {
  data: any;
  pageContext: any;
}

const Blog: FC<BlogProps> = ({ data, pageContext }) => {
  const { blogPosts } = data;

  return (
    <HeadingScope>
      <Header isWhite />
      <Layout layout="Blog">
        <Heading variant={HeadingVariant.ALFA}>News</Heading>
        <Grid columns={4}>
          {blogPosts.edges.map(post => {
            const { slug, title, featuredImage } = post.node.frontmatter;
            return (
              <BlogCard
                key={slug}
                title={title}
                image={featuredImage.childImageSharp.fluid}
                slug={slug}
              />
            );
          })}
        </Grid>
        <Pager pageContext={pageContext} />
      </Layout>
      <Footer />
    </HeadingScope>
  );
};

export default Blog;

export const query = graphql`
  query Blog($skip: Int!, $limit: Int!) {
    blogPosts: allMdx(
      filter: { fileAbsolutePath: { regex: "/news/" } }
      sort: { fields: [frontmatter___date], order: DESC }
      skip: $skip
      limit: $limit
    ) {
      edges {
        node {
          frontmatter {
            slug
            title
            featuredImage {
              childImageSharp {
                fluid(maxWidth: 2000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`;
